/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { CancelReservationPathParameters } from 'api/actions/cancel-reservation/cancel-reservation-path-parameters';
import { CancelReservationResponse } from 'api/actions/cancel-reservation/cancel-reservation-response';

type CancelReservationQueryParameters = Record<string, any>;

/**
 * The path of the CancelReservation action.
 */
export const cancelReservationActionPath = new SweetPath<keyof CancelReservationPathParameters>(
  '/reservations/{id}/cancel',
  { path: '{param}' }
);

/**
 * Creates a contextualized CancelReservation actions.
 */
export default function createCancelReservationAction(axios: AxiosInstance) {
  return function cancelReservationAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: CancelReservationPathParameters;
    query?: CancelReservationQueryParameters;
  }) {
    const path = cancelReservationActionPath.insert(parameters);

    return axios.post<CancelReservationResponse, CancelReservationResponse>(path, { params: query, headers });
  };
}
